import { environment } from '../../../environments/environment';
import { FirebaseClientConfig } from '../../../environments/environment.model';

export const firebaseClientConfig: FirebaseClientConfig = environment.firebase;

export function hasFirebaseClientConfig(
  config: Partial<FirebaseClientConfig>
): config is FirebaseClientConfig {
  return Boolean(
    config.apiKey &&
      config.authDomain &&
      config.projectId &&
      config.appId &&
      config.measurementId
  );
}
